import {
  DEFAULT_TIMEOUT_MS,
  DEFAULT_WARNING_MS,
  DEFAULT_PROBE_MS,
  THROTTLE_MS,
  useSessionTimeout
} from './useSessionTimeout';
import { SessionTimeoutDialog } from './SessionTimeoutDialog';

export {
  DEFAULT_TIMEOUT_MS,
  DEFAULT_WARNING_MS,
  DEFAULT_PROBE_MS,
  THROTTLE_MS
};

const SessionTimeoutHandler = ({
  user,
  timeoutMs = DEFAULT_TIMEOUT_MS,
  warningMs = DEFAULT_WARNING_MS,
  checkIntervalMs = 10 * 1000,
  probeTimeoutMs = DEFAULT_PROBE_MS
}) => {
  const {
    showWarning,
    secondsRemaining,
    handleStaySignedIn,
    handleSignOut
  } = useSessionTimeout({
    user,
    timeoutMs,
    warningMs,
    checkIntervalMs,
    probeTimeoutMs
  });

  if (!user || !showWarning) {
    return null;
  }

  return (
    <SessionTimeoutDialog
      open={showWarning}
      secondsRemaining={secondsRemaining}
      onStaySignedIn={handleStaySignedIn}
      onSignOut={handleSignOut}
    />
  );
};

export default SessionTimeoutHandler;
